export default "__VITE_ASSET__BNv4csKY__"